import React from "react";
import Loadable from "react-loadable";
import { Loading } from "components";
import contents from "./language";

// Material icons
import {
  DashboardOutlined as DashboardIcon,
  PeopleOutlined as PeopleIcon,
  ShoppingBasketOutlined as ShoppingBasketIcon,
  LockOpenOutlined as LockOpenIcon,
  TextFields as TextFieldsIcon,
  ImageOutlined as ImageIcon,
  HourglassEmpty as UnderDevelopmentIcon,
  AccountBoxOutlined as AccountBoxIcon,
  SettingsOutlined as SettingsIcon,
  Done
} from "@material-ui/icons";

const MyLoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <Loading />;
  }
  // Handle the error state
  else if (error) {
    console.log("error", error);
    return (
      <div>متاسفانه در نمایش این صفحه مشکلی بوجود آمده است .منتظر بمانید.</div>
    );
  } else {
    return null;
  }
};

export const dynamicRoutes = (language = null) => {
  // console.log(language, "dynamic");
  return [
    { name: "Dashboard", icon: DashboardIcon, path: "/dashboard" },
    { name: "Users", icon: PeopleIcon, path: "/users" },
    { name: "Products", icon: ShoppingBasketIcon, path: "/products" },
    { name: "Typography", icon: TextFieldsIcon, path: "/typography" },
    { name: "Icons", icon: ImageIcon, path: "/icons" },
    { name: "Account", icon: AccountBoxIcon, path: "/account" },
    { name: "Settings", icon: SettingsIcon, path: "/settings" },
    { name: "Sign-Up", icon: AccountBoxIcon, path: "/sign-up" },
    { name: "Sign-In", icon: LockOpenIcon, path: "/sign-in" },
    { name: "Reset", icon: SettingsIcon, path: "/reset-password" },

    // Atlantis Dashboard Routes
    {
      name: contents["sidebar.network-config"][language || "en"],
      sub: "setting",
      icon: Done,
      path: "/network-config"
    },

    {
      name: contents["sidebar.categories"][language || "en"],
      sub: "category",
      icon: Done,
      path: "/categories"
    },
    {
      name: contents["sidebar.category-properties"][language || "en"],
      sub: "category",
      icon: Done,
      path: "/category-properties"
    },

    {
      name: contents["sidebar.products"][language || "en"],
      sub: "product",
      icon: Done,
      path: "/products"
    },
    {
      name: contents["sidebar.product-prices"][language || "en"],
      sub: "product",
      icon: Done,
      path: "/product-prices"
    },
    {
      name: contents["sidebar.product-warehouses"][language || "en"],
      sub: "product",
      icon: Done,
      path: "/product-warehouses"
    },
    {
      name: contents["sidebar.warehouse-transactions"][language || "en"],
      sub: "product",
      icon: Done,
      path: "/warehouse-transactions"
    },

    {
      name: contents["sidebar.invoices"][language || "en"],
      sub: "commercial-report",
      icon: Done,
      path: "/invoices"
    },

    {
      name: "Under-Development",
      icon: UnderDevelopmentIcon,
      path: "/under-development"
    },
    { name: "Not-Found", icon: ImageIcon, path: "/not-found" }
  ];
};

export default [
  [
    {
      component: Loadable({
        loader: () => import("./views/SignIn"),
        loading: MyLoadingComponent
      }),
      link: "/sign-in",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/SignUp"),
        loading: MyLoadingComponent
      }),
      link: "/sign-up",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Reset"),
        loading: MyLoadingComponent
      }),
      link: "/reset",
      public: true
    }
  ],
  [
    {
      component: Loadable({
        loader: () => import("./views/Dashboard"),
        loading: MyLoadingComponent
      }),
      link: "/dashboard",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/NetworkConfig"),
        loading: MyLoadingComponent
      }),
      link: "/network-config",
      public: false
    },
    {
      component: Loadable({
        loader: () => import("./views/Category/CategoryPage"),
        loading: MyLoadingComponent
      }),
      link: "/categories",
      public: false
    },
    {
      component: Loadable({
        loader: () => import("./views/CategoryProperty/CategoryPropertyPage"),
        loading: MyLoadingComponent
      }),
      link: "/category-properties",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Products"),
        loading: MyLoadingComponent
      }),
      link: "/products",
      public: false
    },
    {
      component: Loadable({
        loader: () => import("./views/ProductPrices/ProductPricePage"),
        loading: MyLoadingComponent
      }),
      link: "/product-prices",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/ProductWarehouses/ProductWarehousesPage"),
        loading: MyLoadingComponent
      }),
      link: "/product-warehouses",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/ProductWarehousesTransactions/ProductWarehousesTransactionsPage"),
        loading: MyLoadingComponent
      }),
      link: "/warehouse-transactions",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/UserList"),
        loading: MyLoadingComponent
      }),
      link: "/invoices",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/UnderDevelopment"),
        loading: MyLoadingComponent
      }),
      link: "/under-development",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/NotFound"),
        loading: MyLoadingComponent
      }),
      link: "/not-found",
      public: true
    }
  ]
];
